const collapsibleRegionPresenter = require('./collapsibleRegionPresenter');
const documentPresenter = require('./documentsPresenter/documentPresenter');
const { deactivate } = require('gui');
const { getTranslationDictionary } = require('core');

module.exports = function documentsPresenter(documents = []) {
    const documentsString = getTranslationDictionary().documents;
    const documentsRegionPresenter = collapsibleRegionPresenter(documentsString);
    const c = {};
    const deactivator = deactivate();

    c.activate = function(region) {
        if(documents.length <= 0)
            return;

        documentsRegionPresenter.activate(region);
        deactivator.add(documentsRegionPresenter);
        const contentRegion = documentsRegionPresenter.contentRegion();
        contentRegion.classList.add('documentsPresenter-region')

        documents.forEach(doc => {
            const presenter = documentPresenter(doc);
            presenter.activate(contentRegion);
            deactivator.add(presenter);
        });
    };

    c.deactivate = function() {
        deactivator();
    };

    return c;
};
